export default __webpack_public_path__ + "static/media/doctor man.4f4b903f.svg";